module.exports = __webpack_public_path__ + "static/media/Final-design.jpg-1.672231c8.jpg";